"use strict";

var _ = require("lodash");

module.exports = /* @ngInject */ function(
  apiFactory,
  eikonSsoService,
  $log,
  $q
) {
  var that = this;
  const entitlementName = "WORKSPACE SSO";

  const isWorkspaceSSOEnabled = openFinWebClientApi => {
    return openFinWebClientApi
      .one(
        `user/entitlements?entitlementName=${encodeURIComponent(
          entitlementName
        )}`
      )
      .get()
      .then(entitlements => {
        if (
          !!entitlements &&
          entitlements.length > 0 &&
          entitlements[0].value === 0
        ) {
          return false;
        } else {
          return true;
        }
      });
  };

  const isEikonUserFromApi = openFinWebClientApi =>
    openFinWebClientApi
      .one("user")
      .get()
      .then(user => {
        if (!!user.eikonUserId) {
          return isWorkspaceSSOEnabled(openFinWebClientApi);
        } else {
          console.log(`User does not have a valid Workspace USER ID`);
          return false;
        }
      });

  that.create = () => apiFactory.create("openFinWebClient", "/openfin/webapi");

  that.isEikonUser = () =>
    that.create().then(
      openFinWebClientApi => {
        return isEikonUserFromApi(openFinWebClientApi);
      },
      error => {
        $log.error("Failed to get user from openfin webapi ", error);
        return false;
      }
    );

  that.createWithEikonTokenHeader = function() {
    return that.create().then(openFinWebClientApi => {
      return isEikonUserFromApi(openFinWebClientApi).then(isEikonUser => {
        console.log(
          `User is ${
            isEikonUser ? "Enabled" : "Not Enabled"
          } to use Workspace SSO`
        );
        if (isEikonUser) {
          return eikonSsoService.getEikonSsoCookie().then(cookies => {
            return openFinWebClientApi.withConfig(config => {
              config.setDefaultHeaders({
                "Eikon-Token": eikonSsoService.extractEikonToken(cookies)
              });
            });
          });
        } else {
          return $q.reject(new Error("User is not mapped to an Eikon user"));
        }
      });
    });
  };

  that.createWithEikonTokenHeaderOrWithoutIt = function() {
    return that.createWithEikonTokenHeader().then(undefined, function(error) {
      $log.info(error);
      return that.create();
    });
  };
};



// WEBPACK FOOTER //
// ./app/infrastructure/factories/openFinWebClientApiFactory.js